<template>
  <v-card class="mb-3 field-card" :class="{ 'field-card--waiting': waiting }" :to="{ name: 'field.order', params: { id: order.id } }">
    <div class="d-flex align-stretch">
      <!-- L'heure d'abord : c'est elle qui ordonne la journée. -->
      <div class="field-card__when" :class="`field-card__when--${day}`">
        <v-icon :color="waiting ? 'grey' : 'primary'">{{ kindIcon(order.kind) }}</v-icon>
        <div v-if="order.scheduledAt" class="field-card__time">{{ whenOf(order) }}</div>
      </div>

      <v-card-text class="pa-3">
        <div class="d-flex align-start">
          <div class="font-weight-bold text-body-1 text--primary">{{ beneficiaryOf(order) }}</div>
          <v-spacer />
          <v-chip v-if="day === 'late'" x-small color="red darken-1" dark class="ml-2">{{ $t('onboarding.field.late') }}</v-chip>
          <v-chip v-else-if="order.installation === 'in-progress'" x-small color="teal" dark class="ml-2">{{ $t('onboarding.field.in-progress') }}</v-chip>
        </div>
        <div class="text-body-2">{{ addressOf(order) }}</div>
        <div class="text-caption text--secondary">
          {{ kindLabel(order.kind) }}<span v-if="order.holder === 'member' && order.organizationName"> · {{ order.organizationName }}</span>
        </div>
        <!-- Pas encore prête : ce qui manque, en un coup d'œil. -->
        <div v-if="waiting && waitingFor(order)" class="text-caption mt-1">
          <v-icon x-small class="mr-1">mdi-timer-sand</v-icon>{{ $t('onboarding.field.waiting-for', { requirements: waitingFor(order) }) }}
        </div>
        <div v-if="order.fieldIssue" class="text-caption red--text text--darken-1 mt-1">
          <v-icon x-small color="red darken-1" class="mr-1">mdi-alert-outline</v-icon>{{ issueReasonLabel(order.fieldIssue.reason) }}
        </div>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import CommissioningMixin from '../CommissioningMixin'
import FieldMixin from './FieldMixin'

/** Une pose dans la liste du portail : quand, chez qui, où. Un doigt suffit pour l'ouvrir. */
export default {
  name: 'FieldOrderCard',

  mixins: [CommissioningMixin, FieldMixin],

  props: {
    order: { type: Object, required: true },
    /** Pas encore prête : on la voit venir, on ne peut pas la prendre. */
    waiting: { type: Boolean, default: false },
  },

  computed: {
    day() {
      return this.dayOf(this.order)
    },
  },
}
</script>

<style scoped>
.field-card__when {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 8px 4px;
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  background: rgba(0, 0, 0, 0.02);
}
.field-card__when--today {
  background: rgba(25, 118, 210, 0.08);
}
.field-card__when--late {
  background: rgba(229, 57, 53, 0.08);
}
.field-card__time {
  font-weight: 600;
  font-size: 0.85rem;
  text-align: center;
  margin-top: 4px;
  line-height: 1.2;
}
.field-card--waiting {
  opacity: 0.65;
}
</style>
